import React, { useContext, useEffect } from 'react';

import { ControlBarContext } from '../ControlBarContext';
import PartnersTable from './components/PartnersTable';

import Provider from './context';

export default function ({ getBreadCrumbs }) {
  const { setBreadCrumbs } = useContext(ControlBarContext);

  useEffect(() => {
    setBreadCrumbs(getBreadCrumbs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider>
      <PartnersTable />
    </Provider>
  );
}
